export const Algodon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.33333 8.33333V11.25C7.7914 11.5629 7.3485 12.0221 7.05529 12.5749C6.76209 13.1277 6.63043 13.7519 6.67538 14.3761C6.72032 15.0003 6.94006 15.5992 7.30946 16.1043C7.67885 16.6094 8.18297 17.0004 8.76414 17.2324C9.34532 17.4645 9.98007 17.5282 10.5958 17.4164C11.2115 17.3045 11.7833 17.0216 12.2457 16.6001C12.7082 16.1785 13.0427 15.6352 13.2108 15.0325C13.379 14.4297 13.3741 13.7918 13.1967 13.1917M11.6667 8.33333V4.16667C11.6667 3.72464 11.4911 3.30072 11.1785 2.98816C10.866 2.67559 10.442 2.5 10 2.5C9.55797 2.5 9.13405 2.67559 8.82149 2.98816C8.50893 3.30072 8.33333 3.72464 8.33333 4.16667V5M10.8333 7.5H11.6667M2.5 2.5L17.5 17.5"
        stroke="#59224C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Algodon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_647_1569)">
        <path
          d="M9.16667 18.3332C12.8486 18.3332 15.8333 15.7215 15.8333 12.4998C15.8333 9.27818 12.8486 6.6665 9.16667 6.6665C5.48477 6.6665 2.5 9.27818 2.5 12.4998C2.5 15.7215 5.48477 18.3332 9.16667 18.3332Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.832 10C11.3874 10.0696 12.4987 10.4167 12.9154 12.0833"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M3.33268 4.99984C4.25316 4.99984 4.99935 4.25365 4.99935 3.33317C4.99935 2.4127 4.25316 1.6665 3.33268 1.6665C2.41221 1.6665 1.66602 2.4127 1.66602 3.33317C1.66602 4.25365 2.41221 4.99984 3.33268 4.99984Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.082 6.6665C17.7724 6.6665 18.332 6.10686 18.332 5.4165C18.332 4.72615 17.7724 4.1665 17.082 4.1665C16.3917 4.1665 15.832 4.72615 15.832 5.4165C15.832 6.10686 16.3917 6.6665 17.082 6.6665Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_647_1569">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Algodon3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.79167 4.79167L15.2083 15.2083M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 9.01509 2.69399 8.03982 3.0709 7.12987C3.44781 6.21993 4.00026 5.39314 4.6967 4.6967C5.39314 4.00026 6.21993 3.44781 7.12987 3.0709C8.03982 2.69399 9.01509 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5Z"
        stroke="#59224C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Algodon4 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_647_1581)">
        <path
          d="M15.4162 13.333H17.0454C17.3355 13.3331 17.6171 13.2352 17.8445 13.0552C18.072 12.8752 18.232 12.6236 18.2987 12.3413C18.3653 12.059 18.3347 11.7625 18.2117 11.4997C18.0888 11.237 17.8807 11.0235 17.6212 10.8938L9.99958 7.08301L2.37791 10.8938C2.11844 11.0235 1.91037 11.237 1.78741 11.4997C1.66445 11.7625 1.63381 12.059 1.70046 12.3413C1.76711 12.6236 1.92714 12.8752 2.15461 13.0552C2.38208 13.2352 2.66367 13.3331 2.95375 13.333H4.58291"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.9987 7.08317C9.9987 7.08317 11.6654 4.254 11.6654 3.33317C11.6654 2.89114 11.4898 2.46722 11.1772 2.15466C10.8646 1.8421 10.4407 1.6665 9.9987 1.6665C9.55667 1.6665 9.13275 1.8421 8.82019 2.15466C8.50763 2.46722 8.33203 2.89114 8.33203 3.33317M4.58203 12.4998H15.4154V18.3332H4.58203V12.4998Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_647_1581">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Algodon5 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 12.5H10.0083M7.5 5H13.7158C14.3076 5.00004 14.8802 5.21001 15.3317 5.59256C15.7832 5.97511 16.0844 6.50543 16.1817 7.08917L16.6625 9.97583L17.3375 14.03C17.3573 14.1493 17.351 14.2714 17.3189 14.388C17.2868 14.5045 17.2297 14.6127 17.1516 14.705C17.0735 14.7973 16.9762 14.8715 16.8666 14.9224C16.757 14.9733 16.6376 14.9998 16.5167 15H2.5C2.5 13.4529 3.11458 11.9692 4.20854 10.8752C5.30251 9.78125 6.78624 9.16667 8.33333 9.16667H16.5M7.5 12.5H7.50833M12.5 12.5H12.5083"
        stroke="#59224C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
